/*eslint-disable */

import {bus} from '@/main';
import countries from '@/services/country.json';

export default {
  name: 'item-info-popup',
  components: {},
  props: ['demoReqInfoData'],
  data () {
    return {
      domainLocationOrigin:'',
      countryList:[]
    }
  },
  computed: {

  },
  mounted () {
    this.domainLocationOrigin = process.env.VUE_APP_PUBLIC_URL;
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1);
  },
  methods: {
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
    closeDemoRequestInfoPopup() {
      bus.$emit('demoReqInfoStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}